import { useEffect, useState } from "react";
import { MessageCircle, X } from "lucide-react";
import api from "@/lib/api";

export default function WhatsAppFloat() {
  const [settings, setSettings] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  if (!settings || settings.whatsapp_float_enabled === false) return null;
  const number = (settings.admin_whatsapp || "").replace(/\D/g, "");
  if (!number) return null;

  const businessName = settings.business_name || "Rental PS";
  const defaultMsg = settings.whatsapp_float_message || "Halo, saya mau tanya tentang rental PS";
  const link = `https://wa.me/${number}?text=${encodeURIComponent(defaultMsg)}`;

  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col items-end gap-3" data-testid="wa-float">
      {open && (
        <div className="max-w-xs bg-[#0F0F11] border border-[#00E5FF]/40 shadow-2xl overflow-hidden" data-testid="wa-float-panel">
          <div className="flex items-center justify-between p-4 border-b border-white/10 bg-[#00E5FF]/5">
            <div>
              <div className="text-xs uppercase tracking-widest text-[#00E5FF] font-semibold">Live Chat</div>
              <div className="font-heading font-bold text-white text-sm mt-0.5">{businessName}</div>
            </div>
            <button onClick={() => setOpen(false)} className="text-gray-400 hover:text-white" data-testid="wa-float-close">
              <X size={16} />
            </button>
          </div>
          <div className="p-4">
            <p className="text-sm text-gray-300 leading-relaxed">
              Ada pertanyaan tentang booking atau turnamen? Chat langsung dengan admin kami di WhatsApp.
            </p>
            <a
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="wa-float-chat-link"
              className="mt-4 inline-flex items-center justify-center gap-2 w-full bg-[#25D366] text-white font-bold py-2.5 text-sm uppercase tracking-wider hover:bg-[#128C7E] transition-colors"
            >
              <MessageCircle size={16} /> Mulai Chat
            </a>
            <div className="mt-2 text-[10px] text-gray-500 text-center">+{number}</div>
          </div>
        </div>
      )}
      <button
        onClick={() => setOpen(!open)}
        data-testid="wa-float-btn"
        aria-label="Chat WhatsApp"
        className="relative w-14 h-14 flex items-center justify-center bg-[#25D366] text-white shadow-lg hover:scale-105 transition-transform"
        style={{ boxShadow: "0 4px 24px rgba(37, 211, 102, 0.5)" }}
      >
        <span className="absolute inset-0 rounded-none bg-[#25D366] animate-ping opacity-30" />
        <MessageCircle size={26} strokeWidth={2} className="relative" />
      </button>
    </div>
  );
}
